import { GMDialog } from '..';
import { useLocalization } from '../../../context/Localization/localization';
import { GMButton } from '../../Button';
import { DialogInfoProps } from './DialogInfo.types';

/**
 * A Dialog component that displays information to the user.
 *
 * @param ariaLabel - {@link DialogInfoProps.ariaLabel ariaLabel} description.
 * @param ariaDescribedBy - {@link DialogInfoProps.ariaDescribedBy ariaDescribedBy} description.
 * @param title - {@link DialogInfoProps.title title} description.
 * @param open - {@link DialogInfoProps.open open} description.
 * @param onClose - {@link DialogInfoProps.onClose onClose} description.
 * @param className - {@link DialogInfoProps.className className} description.
 * @param children - {@link DialogInfoProps.children children} description.
 */
const DialogInfo = ({
    ariaLabel,
    ariaDescribedBy,
    title,
    className,
    paperDialogClasses,
    open,
    onClose,
    closeButtonText,
    children,
}: DialogInfoProps) => {
    const Localization = useLocalization();

    return (
        <GMDialog
            ariaLabel={ariaLabel}
            ariaDescribedBy={ariaDescribedBy}
            title={title}
            className={className}
            paperDialogClasses={paperDialogClasses}
            open={open}
            onClose={onClose}
            actions={[
                <GMButton
                    id={Localization.Close}
                    title={Localization.Close}
                    ariaLabel={Localization.Close}
                    onClick={onClose}
                >
                    {closeButtonText ? closeButtonText : Localization.Close}
                </GMButton>,
            ]}
        >
            {children}
        </GMDialog>
    );
};

export default DialogInfo;